/**
 * 🏷️ Status Badge Utilities
 * يدير styling والعرض لشارات حالة الموظفين
 */

import React from "react";

/**
 * ✅ Get styled status badge
 * @param {String} status - حالة الموظف (Active, OnLeave, Inactive, Archived)
 * @param {Object} text - نصوص اللغة
 * @param {String} language - اللغة الحالية (ar/en)
 * @param {String} screenSize - حجم الشاشة (xs, sm, md, lg, xl, xxl)
 * @param {Object} fonts - كائن الخطوط
 * @returns {JSX.Element} عنصر Badge مصمم
 */
export const getStatusBadge = (status, text, language, screenSize, fonts) => {
  // Base styles for all status badges
  const baseStyle = {
    padding: screenSize === "xs" ? "0.25rem 0.5rem" : "0.25rem 0.625rem",
    borderRadius: screenSize === "xs" ? "0.5rem" : "0.75rem",
    fontSize: fonts?.small || "0.875rem",
    fontWeight: "600",
    display: "inline-block",
    whiteSpace: "nowrap",
  };

  // Status color mappings
  const statusStyles = {
    Active: {
      backgroundColor: "#d1fae5",
      color: "#065f46",
      label: text?.[language]?.statusActive || "نشط",
    },
    OnLeave: {
      backgroundColor: "#fef3c7",
      color: "#92400e",
      label: text?.[language]?.statusOnLeave || "في إجازة",
    },
    Inactive: {
      backgroundColor: "#fee2e2",
      color: "#991b1b",
      label: text?.[language]?.statusInactive || "غير نشط",
    },
    Archived: {
      backgroundColor: "#e5e7eb",
      color: "#6b7280",
      label: text?.[language]?.statusArchived || "مؤرشف",
    },
  };

  const statusStyle = statusStyles[status] || statusStyles.Archived;

  return (
    <span
      style={{
        ...baseStyle,
        backgroundColor: statusStyle.backgroundColor,
        color: statusStyle.color,
      }}
    >
      {statusStyle.label}
    </span>
  );
};

/**
 * ✅ Status color configuration
 * Returns color info for a given status
 * @param {String} status - حالة الموظف
 * @returns {Object} { backgroundColor, color, label }
 */
export const getStatusConfig = (status) => {
  const statusConfigs = {
    Active: {
      backgroundColor: "#d1fae5",
      color: "#065f46",
      lightBg: "#ecfdf5",
      borderColor: "#a7f3d0",
    },
    OnLeave: {
      backgroundColor: "#fef3c7",
      color: "#92400e",
      lightBg: "#fffbeb",
      borderColor: "#fcd34d",
    },
    Inactive: {
      backgroundColor: "#fee2e2",
      color: "#991b1b",
      lightBg: "#fef2f2",
      borderColor: "#fca5a5",
    },
    Archived: {
      backgroundColor: "#e5e7eb",
      color: "#6b7280",
      lightBg: "#f3f4f6",
      borderColor: "#d1d5db",
    },
  };

  return statusConfigs[status] || statusConfigs.Archived;
};
